// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies
// @generated from protobuf file "backend/client_service.proto" (package "tusk.drift.backend.v1", syntax proto3)
// tslint:disable
import { ServiceType as ServiceType$ } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetAuthInfoRequest
 */
export interface GetAuthInfoRequest {
    /**
     * @generated from protobuf field: optional string client_id = 1
     */
    clientId?: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.UserAuthInfo
 */
export interface UserAuthInfo {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: tusk.drift.backend.v1.UserType type = 2
     */
    type: UserType;
    /**
     * @generated from protobuf field: string name = 3
     */
    name: string;
    /**
     * @generated from protobuf field: optional string email = 4
     */
    email?: string;
    /**
     * @generated from protobuf field: optional string code_hosting_username = 5
     */
    codeHostingUsername?: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.AuthInfoClient
 */
export interface AuthInfoClient {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: optional string name = 2
     */
    name?: string;
    /**
     * @generated from protobuf field: optional string domain = 3
     */
    domain?: string;
    /**
     * @generated from protobuf field: repeated string feature_flags = 4
     */
    featureFlags: string[];
    /**
     * @generated from protobuf field: repeated tusk.drift.backend.v1.CodeHostingResource code_hosting_resources = 5
     */
    codeHostingResources: CodeHostingResource[];
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.CodeHostingResource
 */
export interface CodeHostingResource {
    /**
     * @generated from protobuf field: int64 id = 1
     */
    id: bigint;
    /**
     * @generated from protobuf field: tusk.drift.backend.v1.CodeHostingResourceType type = 2
     */
    type: CodeHostingResourceType;
    /**
     * @generated from protobuf field: string external_id = 3
     */
    externalId: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.GetAuthInfoResponse
 */
export interface GetAuthInfoResponse {
    /**
     * @generated from protobuf field: tusk.drift.backend.v1.UserAuthInfo user = 1
     */
    user?: UserAuthInfo;
    /**
     * @generated from protobuf field: repeated tusk.drift.backend.v1.AuthInfoClient clients = 2
     */
    clients: AuthInfoClient[];
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.CreateObservableServiceRequest
 */
export interface CreateObservableServiceRequest {
    /**
     * @generated from protobuf field: string repo_owner_name = 1
     */
    repoOwnerName: string;
    /**
     * @generated from protobuf field: string repo_name = 2
     */
    repoName: string;
    /**
     * @generated from protobuf field: tusk.drift.backend.v1.ServiceType service_type = 3
     */
    serviceType: ServiceType;
    /**
     * @generated from protobuf field: optional string app_dir = 4
     */
    appDir?: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.CreateObservableServiceResponseSuccess
 */
export interface CreateObservableServiceResponseSuccess {
    /**
     * @generated from protobuf field: string observable_service_id = 1
     */
    observableServiceId: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.CreateObservableServiceResponseError
 */
export interface CreateObservableServiceResponseError {
    /**
     * @generated from protobuf field: tusk.drift.backend.v1.CreateObservableServiceResponseErrorCode code = 1
     */
    code: CreateObservableServiceResponseErrorCode;
    /**
     * @generated from protobuf field: string message = 2
     */
    message: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.CreateObservableServiceResponse
 */
export interface CreateObservableServiceResponse {
    /**
     * @generated from protobuf oneof: response
     */
    response: {
        oneofKind: "success";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.CreateObservableServiceResponseSuccess success = 1
         */
        success: CreateObservableServiceResponseSuccess;
    } | {
        oneofKind: "error";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.CreateObservableServiceResponseError error = 2
         */
        error: CreateObservableServiceResponseError;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.VerifyRepoAccessRequest
 */
export interface VerifyRepoAccessRequest {
    /**
     * @generated from protobuf field: string repo_owner_name = 1
     */
    repoOwnerName: string;
    /**
     * @generated from protobuf field: string repo_name = 2
     */
    repoName: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.VerifyRepoAccessResponseSuccess
 */
export interface VerifyRepoAccessResponseSuccess {
    /**
     * @generated from protobuf field: int64 repo_id = 1
     */
    repoId: bigint;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.VerifyRepoAccessResponseError
 */
export interface VerifyRepoAccessResponseError {
    /**
     * @generated from protobuf field: tusk.drift.backend.v1.VerifyRepoAccessResponseErrorCode code = 1
     */
    code: VerifyRepoAccessResponseErrorCode;
    /**
     * @generated from protobuf field: string message = 2
     */
    message: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.VerifyRepoAccessResponse
 */
export interface VerifyRepoAccessResponse {
    /**
     * @generated from protobuf oneof: response
     */
    response: {
        oneofKind: "success";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.VerifyRepoAccessResponseSuccess success = 1
         */
        success: VerifyRepoAccessResponseSuccess;
    } | {
        oneofKind: "error";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.VerifyRepoAccessResponseError error = 2
         */
        error: VerifyRepoAccessResponseError;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.CreateApiKeyRequest
 */
export interface CreateApiKeyRequest {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.CreateApiKeyResponse
 */
export interface CreateApiKeyResponse {
    /**
     * @generated from protobuf oneof: response
     */
    response: {
        oneofKind: "success";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.CreateApiKeyResponseSuccess success = 1
         */
        success: CreateApiKeyResponseSuccess;
    } | {
        oneofKind: "error";
        /**
         * @generated from protobuf field: tusk.drift.backend.v1.CreateApiKeyResponseError error = 2
         */
        error: CreateApiKeyResponseError;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.CreateApiKeyResponseSuccess
 */
export interface CreateApiKeyResponseSuccess {
    /**
     * @generated from protobuf field: string api_key_id = 1
     */
    apiKeyId: string;
    /**
     * @generated from protobuf field: string api_key = 2
     */
    apiKey: string;
}
/**
 * @generated from protobuf message tusk.drift.backend.v1.CreateApiKeyResponseError
 */
export interface CreateApiKeyResponseError {
    /**
     * @generated from protobuf field: tusk.drift.backend.v1.CreateApiKeyResponseErrorCode code = 1
     */
    code: CreateApiKeyResponseErrorCode;
    /**
     * @generated from protobuf field: string message = 2
     */
    message: string;
}
/**
 * @generated from protobuf enum tusk.drift.backend.v1.UserType
 */
export enum UserType {
    /**
     * @generated from protobuf enum value: USER_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: USER_TYPE_USER = 1;
     */
    USER = 1,
    /**
     * @generated from protobuf enum value: USER_TYPE_API_KEY = 2;
     */
    API_KEY = 2
}
/**
 * @generated from protobuf enum tusk.drift.backend.v1.CodeHostingResourceType
 */
export enum CodeHostingResourceType {
    /**
     * @generated from protobuf enum value: CODE_HOSTING_RESOURCE_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: CODE_HOSTING_RESOURCE_TYPE_GITHUB = 1;
     */
    GITHUB = 1,
    /**
     * @generated from protobuf enum value: CODE_HOSTING_RESOURCE_TYPE_GITLAB = 2;
     */
    GITLAB = 2
}
/**
 * @generated from protobuf enum tusk.drift.backend.v1.ServiceType
 */
export enum ServiceType {
    /**
     * @generated from protobuf enum value: SERVICE_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: SERVICE_TYPE_NODE = 1;
     */
    NODE = 1
}
/**
 * @generated from protobuf enum tusk.drift.backend.v1.CreateObservableServiceResponseErrorCode
 */
export enum CreateObservableServiceResponseErrorCode {
    /**
     * @generated from protobuf enum value: CREATE_OBSERVABLE_SERVICE_RESPONSE_ERROR_CODE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: CREATE_OBSERVABLE_SERVICE_RESPONSE_ERROR_CODE_INTERNAL = 1;
     */
    INTERNAL = 1,
    /**
     * @generated from protobuf enum value: CREATE_OBSERVABLE_SERVICE_RESPONSE_ERROR_CODE_NOT_AUTHORIZED = 2;
     */
    NOT_AUTHORIZED = 2,
    /**
     * @generated from protobuf enum value: CREATE_OBSERVABLE_SERVICE_RESPONSE_ERROR_CODE_NO_CODE_HOSTING_RESOURCE = 3;
     */
    NO_CODE_HOSTING_RESOURCE = 3,
    /**
     * @generated from protobuf enum value: CREATE_OBSERVABLE_SERVICE_RESPONSE_ERROR_CODE_NO_REPO_FOUND = 4;
     */
    NO_REPO_FOUND = 4
}
/**
 * @generated from protobuf enum tusk.drift.backend.v1.VerifyRepoAccessResponseErrorCode
 */
export enum VerifyRepoAccessResponseErrorCode {
    /**
     * @generated from protobuf enum value: VERIFY_REPO_ACCESS_RESPONSE_ERROR_CODE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: VERIFY_REPO_ACCESS_RESPONSE_ERROR_CODE_INTERNAL = 1;
     */
    INTERNAL = 1,
    /**
     * @generated from protobuf enum value: VERIFY_REPO_ACCESS_RESPONSE_ERROR_CODE_NOT_AUTHORIZED = 2;
     */
    NOT_AUTHORIZED = 2,
    /**
     * @generated from protobuf enum value: VERIFY_REPO_ACCESS_RESPONSE_ERROR_CODE_NO_CODE_HOSTING_RESOURCE = 3;
     */
    NO_CODE_HOSTING_RESOURCE = 3,
    /**
     * @generated from protobuf enum value: VERIFY_REPO_ACCESS_RESPONSE_ERROR_CODE_REPO_NOT_FOUND = 4;
     */
    REPO_NOT_FOUND = 4
}
/**
 * @generated from protobuf enum tusk.drift.backend.v1.CreateApiKeyResponseErrorCode
 */
export enum CreateApiKeyResponseErrorCode {
    /**
     * @generated from protobuf enum value: CREATE_API_KEY_RESPONSE_ERROR_CODE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: CREATE_API_KEY_RESPONSE_ERROR_CODE_INTERNAL = 1;
     */
    INTERNAL = 1,
    /**
     * @generated from protobuf enum value: CREATE_API_KEY_RESPONSE_ERROR_CODE_NOT_AUTHORIZED = 2;
     */
    NOT_AUTHORIZED = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class GetAuthInfoRequest$Type extends MessageType<GetAuthInfoRequest> {
    constructor() {
        super("tusk.drift.backend.v1.GetAuthInfoRequest", [
            { no: 1, name: "client_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetAuthInfoRequest>): GetAuthInfoRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAuthInfoRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAuthInfoRequest): GetAuthInfoRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string client_id */ 1:
                    message.clientId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAuthInfoRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string client_id = 1; */
        if (message.clientId !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.clientId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetAuthInfoRequest
 */
export const GetAuthInfoRequest = new GetAuthInfoRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAuthInfo$Type extends MessageType<UserAuthInfo> {
    constructor() {
        super("tusk.drift.backend.v1.UserAuthInfo", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "enum", T: () => ["tusk.drift.backend.v1.UserType", UserType, "USER_TYPE_"] },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "email", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "code_hosting_username", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UserAuthInfo>): UserAuthInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.type = 0;
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<UserAuthInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAuthInfo): UserAuthInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* tusk.drift.backend.v1.UserType type */ 2:
                    message.type = reader.int32();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* optional string email */ 4:
                    message.email = reader.string();
                    break;
                case /* optional string code_hosting_username */ 5:
                    message.codeHostingUsername = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAuthInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* tusk.drift.backend.v1.UserType type = 2; */
        if (message.type !== 0)
            writer.tag(2, WireType.Varint).int32(message.type);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* optional string email = 4; */
        if (message.email !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.email);
        /* optional string code_hosting_username = 5; */
        if (message.codeHostingUsername !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.codeHostingUsername);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.UserAuthInfo
 */
export const UserAuthInfo = new UserAuthInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthInfoClient$Type extends MessageType<AuthInfoClient> {
    constructor() {
        super("tusk.drift.backend.v1.AuthInfoClient", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "domain", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "feature_flags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "code_hosting_resources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CodeHostingResource }
        ]);
    }
    create(value?: PartialMessage<AuthInfoClient>): AuthInfoClient {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.featureFlags = [];
        message.codeHostingResources = [];
        if (value !== undefined)
            reflectionMergePartial<AuthInfoClient>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AuthInfoClient): AuthInfoClient {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* optional string name */ 2:
                    message.name = reader.string();
                    break;
                case /* optional string domain */ 3:
                    message.domain = reader.string();
                    break;
                case /* repeated string feature_flags */ 4:
                    message.featureFlags.push(reader.string());
                    break;
                case /* repeated tusk.drift.backend.v1.CodeHostingResource code_hosting_resources */ 5:
                    message.codeHostingResources.push(CodeHostingResource.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AuthInfoClient, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* optional string name = 2; */
        if (message.name !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* optional string domain = 3; */
        if (message.domain !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.domain);
        /* repeated string feature_flags = 4; */
        for (let i = 0; i < message.featureFlags.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.featureFlags[i]);
        /* repeated tusk.drift.backend.v1.CodeHostingResource code_hosting_resources = 5; */
        for (let i = 0; i < message.codeHostingResources.length; i++)
            CodeHostingResource.internalBinaryWrite(message.codeHostingResources[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.AuthInfoClient
 */
export const AuthInfoClient = new AuthInfoClient$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CodeHostingResource$Type extends MessageType<CodeHostingResource> {
    constructor() {
        super("tusk.drift.backend.v1.CodeHostingResource", [
            { no: 1, name: "id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "type", kind: "enum", T: () => ["tusk.drift.backend.v1.CodeHostingResourceType", CodeHostingResourceType, "CODE_HOSTING_RESOURCE_TYPE_"] },
            { no: 3, name: "external_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CodeHostingResource>): CodeHostingResource {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0n;
        message.type = 0;
        message.externalId = "";
        if (value !== undefined)
            reflectionMergePartial<CodeHostingResource>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CodeHostingResource): CodeHostingResource {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 id */ 1:
                    message.id = reader.int64().toBigInt();
                    break;
                case /* tusk.drift.backend.v1.CodeHostingResourceType type */ 2:
                    message.type = reader.int32();
                    break;
                case /* string external_id */ 3:
                    message.externalId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CodeHostingResource, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 id = 1; */
        if (message.id !== 0n)
            writer.tag(1, WireType.Varint).int64(message.id);
        /* tusk.drift.backend.v1.CodeHostingResourceType type = 2; */
        if (message.type !== 0)
            writer.tag(2, WireType.Varint).int32(message.type);
        /* string external_id = 3; */
        if (message.externalId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.externalId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.CodeHostingResource
 */
export const CodeHostingResource = new CodeHostingResource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAuthInfoResponse$Type extends MessageType<GetAuthInfoResponse> {
    constructor() {
        super("tusk.drift.backend.v1.GetAuthInfoResponse", [
            { no: 1, name: "user", kind: "message", T: () => UserAuthInfo },
            { no: 2, name: "clients", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AuthInfoClient }
        ]);
    }
    create(value?: PartialMessage<GetAuthInfoResponse>): GetAuthInfoResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.clients = [];
        if (value !== undefined)
            reflectionMergePartial<GetAuthInfoResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAuthInfoResponse): GetAuthInfoResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.backend.v1.UserAuthInfo user */ 1:
                    message.user = UserAuthInfo.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* repeated tusk.drift.backend.v1.AuthInfoClient clients */ 2:
                    message.clients.push(AuthInfoClient.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAuthInfoResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.backend.v1.UserAuthInfo user = 1; */
        if (message.user)
            UserAuthInfo.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated tusk.drift.backend.v1.AuthInfoClient clients = 2; */
        for (let i = 0; i < message.clients.length; i++)
            AuthInfoClient.internalBinaryWrite(message.clients[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.GetAuthInfoResponse
 */
export const GetAuthInfoResponse = new GetAuthInfoResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateObservableServiceRequest$Type extends MessageType<CreateObservableServiceRequest> {
    constructor() {
        super("tusk.drift.backend.v1.CreateObservableServiceRequest", [
            { no: 1, name: "repo_owner_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "repo_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "service_type", kind: "enum", T: () => ["tusk.drift.backend.v1.ServiceType", ServiceType, "SERVICE_TYPE_"] },
            { no: 4, name: "app_dir", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateObservableServiceRequest>): CreateObservableServiceRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.repoOwnerName = "";
        message.repoName = "";
        message.serviceType = 0;
        if (value !== undefined)
            reflectionMergePartial<CreateObservableServiceRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateObservableServiceRequest): CreateObservableServiceRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string repo_owner_name */ 1:
                    message.repoOwnerName = reader.string();
                    break;
                case /* string repo_name */ 2:
                    message.repoName = reader.string();
                    break;
                case /* tusk.drift.backend.v1.ServiceType service_type */ 3:
                    message.serviceType = reader.int32();
                    break;
                case /* optional string app_dir */ 4:
                    message.appDir = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateObservableServiceRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string repo_owner_name = 1; */
        if (message.repoOwnerName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.repoOwnerName);
        /* string repo_name = 2; */
        if (message.repoName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.repoName);
        /* tusk.drift.backend.v1.ServiceType service_type = 3; */
        if (message.serviceType !== 0)
            writer.tag(3, WireType.Varint).int32(message.serviceType);
        /* optional string app_dir = 4; */
        if (message.appDir !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.appDir);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.CreateObservableServiceRequest
 */
export const CreateObservableServiceRequest = new CreateObservableServiceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateObservableServiceResponseSuccess$Type extends MessageType<CreateObservableServiceResponseSuccess> {
    constructor() {
        super("tusk.drift.backend.v1.CreateObservableServiceResponseSuccess", [
            { no: 1, name: "observable_service_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateObservableServiceResponseSuccess>): CreateObservableServiceResponseSuccess {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.observableServiceId = "";
        if (value !== undefined)
            reflectionMergePartial<CreateObservableServiceResponseSuccess>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateObservableServiceResponseSuccess): CreateObservableServiceResponseSuccess {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string observable_service_id */ 1:
                    message.observableServiceId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateObservableServiceResponseSuccess, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string observable_service_id = 1; */
        if (message.observableServiceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.observableServiceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.CreateObservableServiceResponseSuccess
 */
export const CreateObservableServiceResponseSuccess = new CreateObservableServiceResponseSuccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateObservableServiceResponseError$Type extends MessageType<CreateObservableServiceResponseError> {
    constructor() {
        super("tusk.drift.backend.v1.CreateObservableServiceResponseError", [
            { no: 1, name: "code", kind: "enum", T: () => ["tusk.drift.backend.v1.CreateObservableServiceResponseErrorCode", CreateObservableServiceResponseErrorCode, "CREATE_OBSERVABLE_SERVICE_RESPONSE_ERROR_CODE_"] },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateObservableServiceResponseError>): CreateObservableServiceResponseError {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.code = 0;
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<CreateObservableServiceResponseError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateObservableServiceResponseError): CreateObservableServiceResponseError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.backend.v1.CreateObservableServiceResponseErrorCode code */ 1:
                    message.code = reader.int32();
                    break;
                case /* string message */ 2:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateObservableServiceResponseError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.backend.v1.CreateObservableServiceResponseErrorCode code = 1; */
        if (message.code !== 0)
            writer.tag(1, WireType.Varint).int32(message.code);
        /* string message = 2; */
        if (message.message !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.CreateObservableServiceResponseError
 */
export const CreateObservableServiceResponseError = new CreateObservableServiceResponseError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateObservableServiceResponse$Type extends MessageType<CreateObservableServiceResponse> {
    constructor() {
        super("tusk.drift.backend.v1.CreateObservableServiceResponse", [
            { no: 1, name: "success", kind: "message", oneof: "response", T: () => CreateObservableServiceResponseSuccess },
            { no: 2, name: "error", kind: "message", oneof: "response", T: () => CreateObservableServiceResponseError }
        ]);
    }
    create(value?: PartialMessage<CreateObservableServiceResponse>): CreateObservableServiceResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.response = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<CreateObservableServiceResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateObservableServiceResponse): CreateObservableServiceResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.backend.v1.CreateObservableServiceResponseSuccess success */ 1:
                    message.response = {
                        oneofKind: "success",
                        success: CreateObservableServiceResponseSuccess.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).success)
                    };
                    break;
                case /* tusk.drift.backend.v1.CreateObservableServiceResponseError error */ 2:
                    message.response = {
                        oneofKind: "error",
                        error: CreateObservableServiceResponseError.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).error)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateObservableServiceResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.backend.v1.CreateObservableServiceResponseSuccess success = 1; */
        if (message.response.oneofKind === "success")
            CreateObservableServiceResponseSuccess.internalBinaryWrite(message.response.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.backend.v1.CreateObservableServiceResponseError error = 2; */
        if (message.response.oneofKind === "error")
            CreateObservableServiceResponseError.internalBinaryWrite(message.response.error, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.CreateObservableServiceResponse
 */
export const CreateObservableServiceResponse = new CreateObservableServiceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VerifyRepoAccessRequest$Type extends MessageType<VerifyRepoAccessRequest> {
    constructor() {
        super("tusk.drift.backend.v1.VerifyRepoAccessRequest", [
            { no: 1, name: "repo_owner_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "repo_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<VerifyRepoAccessRequest>): VerifyRepoAccessRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.repoOwnerName = "";
        message.repoName = "";
        if (value !== undefined)
            reflectionMergePartial<VerifyRepoAccessRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VerifyRepoAccessRequest): VerifyRepoAccessRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string repo_owner_name */ 1:
                    message.repoOwnerName = reader.string();
                    break;
                case /* string repo_name */ 2:
                    message.repoName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VerifyRepoAccessRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string repo_owner_name = 1; */
        if (message.repoOwnerName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.repoOwnerName);
        /* string repo_name = 2; */
        if (message.repoName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.repoName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.VerifyRepoAccessRequest
 */
export const VerifyRepoAccessRequest = new VerifyRepoAccessRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VerifyRepoAccessResponseSuccess$Type extends MessageType<VerifyRepoAccessResponseSuccess> {
    constructor() {
        super("tusk.drift.backend.v1.VerifyRepoAccessResponseSuccess", [
            { no: 1, name: "repo_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<VerifyRepoAccessResponseSuccess>): VerifyRepoAccessResponseSuccess {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.repoId = 0n;
        if (value !== undefined)
            reflectionMergePartial<VerifyRepoAccessResponseSuccess>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VerifyRepoAccessResponseSuccess): VerifyRepoAccessResponseSuccess {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 repo_id */ 1:
                    message.repoId = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VerifyRepoAccessResponseSuccess, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 repo_id = 1; */
        if (message.repoId !== 0n)
            writer.tag(1, WireType.Varint).int64(message.repoId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.VerifyRepoAccessResponseSuccess
 */
export const VerifyRepoAccessResponseSuccess = new VerifyRepoAccessResponseSuccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VerifyRepoAccessResponseError$Type extends MessageType<VerifyRepoAccessResponseError> {
    constructor() {
        super("tusk.drift.backend.v1.VerifyRepoAccessResponseError", [
            { no: 1, name: "code", kind: "enum", T: () => ["tusk.drift.backend.v1.VerifyRepoAccessResponseErrorCode", VerifyRepoAccessResponseErrorCode, "VERIFY_REPO_ACCESS_RESPONSE_ERROR_CODE_"] },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<VerifyRepoAccessResponseError>): VerifyRepoAccessResponseError {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.code = 0;
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<VerifyRepoAccessResponseError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VerifyRepoAccessResponseError): VerifyRepoAccessResponseError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.backend.v1.VerifyRepoAccessResponseErrorCode code */ 1:
                    message.code = reader.int32();
                    break;
                case /* string message */ 2:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VerifyRepoAccessResponseError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.backend.v1.VerifyRepoAccessResponseErrorCode code = 1; */
        if (message.code !== 0)
            writer.tag(1, WireType.Varint).int32(message.code);
        /* string message = 2; */
        if (message.message !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.VerifyRepoAccessResponseError
 */
export const VerifyRepoAccessResponseError = new VerifyRepoAccessResponseError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VerifyRepoAccessResponse$Type extends MessageType<VerifyRepoAccessResponse> {
    constructor() {
        super("tusk.drift.backend.v1.VerifyRepoAccessResponse", [
            { no: 1, name: "success", kind: "message", oneof: "response", T: () => VerifyRepoAccessResponseSuccess },
            { no: 2, name: "error", kind: "message", oneof: "response", T: () => VerifyRepoAccessResponseError }
        ]);
    }
    create(value?: PartialMessage<VerifyRepoAccessResponse>): VerifyRepoAccessResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.response = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<VerifyRepoAccessResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VerifyRepoAccessResponse): VerifyRepoAccessResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.backend.v1.VerifyRepoAccessResponseSuccess success */ 1:
                    message.response = {
                        oneofKind: "success",
                        success: VerifyRepoAccessResponseSuccess.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).success)
                    };
                    break;
                case /* tusk.drift.backend.v1.VerifyRepoAccessResponseError error */ 2:
                    message.response = {
                        oneofKind: "error",
                        error: VerifyRepoAccessResponseError.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).error)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VerifyRepoAccessResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.backend.v1.VerifyRepoAccessResponseSuccess success = 1; */
        if (message.response.oneofKind === "success")
            VerifyRepoAccessResponseSuccess.internalBinaryWrite(message.response.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.backend.v1.VerifyRepoAccessResponseError error = 2; */
        if (message.response.oneofKind === "error")
            VerifyRepoAccessResponseError.internalBinaryWrite(message.response.error, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.VerifyRepoAccessResponse
 */
export const VerifyRepoAccessResponse = new VerifyRepoAccessResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateApiKeyRequest$Type extends MessageType<CreateApiKeyRequest> {
    constructor() {
        super("tusk.drift.backend.v1.CreateApiKeyRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateApiKeyRequest>): CreateApiKeyRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial<CreateApiKeyRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateApiKeyRequest): CreateApiKeyRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateApiKeyRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.CreateApiKeyRequest
 */
export const CreateApiKeyRequest = new CreateApiKeyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateApiKeyResponse$Type extends MessageType<CreateApiKeyResponse> {
    constructor() {
        super("tusk.drift.backend.v1.CreateApiKeyResponse", [
            { no: 1, name: "success", kind: "message", oneof: "response", T: () => CreateApiKeyResponseSuccess },
            { no: 2, name: "error", kind: "message", oneof: "response", T: () => CreateApiKeyResponseError }
        ]);
    }
    create(value?: PartialMessage<CreateApiKeyResponse>): CreateApiKeyResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.response = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<CreateApiKeyResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateApiKeyResponse): CreateApiKeyResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.backend.v1.CreateApiKeyResponseSuccess success */ 1:
                    message.response = {
                        oneofKind: "success",
                        success: CreateApiKeyResponseSuccess.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).success)
                    };
                    break;
                case /* tusk.drift.backend.v1.CreateApiKeyResponseError error */ 2:
                    message.response = {
                        oneofKind: "error",
                        error: CreateApiKeyResponseError.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).error)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateApiKeyResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.backend.v1.CreateApiKeyResponseSuccess success = 1; */
        if (message.response.oneofKind === "success")
            CreateApiKeyResponseSuccess.internalBinaryWrite(message.response.success, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* tusk.drift.backend.v1.CreateApiKeyResponseError error = 2; */
        if (message.response.oneofKind === "error")
            CreateApiKeyResponseError.internalBinaryWrite(message.response.error, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.CreateApiKeyResponse
 */
export const CreateApiKeyResponse = new CreateApiKeyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateApiKeyResponseSuccess$Type extends MessageType<CreateApiKeyResponseSuccess> {
    constructor() {
        super("tusk.drift.backend.v1.CreateApiKeyResponseSuccess", [
            { no: 1, name: "api_key_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "api_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateApiKeyResponseSuccess>): CreateApiKeyResponseSuccess {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.apiKeyId = "";
        message.apiKey = "";
        if (value !== undefined)
            reflectionMergePartial<CreateApiKeyResponseSuccess>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateApiKeyResponseSuccess): CreateApiKeyResponseSuccess {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string api_key_id */ 1:
                    message.apiKeyId = reader.string();
                    break;
                case /* string api_key */ 2:
                    message.apiKey = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateApiKeyResponseSuccess, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string api_key_id = 1; */
        if (message.apiKeyId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.apiKeyId);
        /* string api_key = 2; */
        if (message.apiKey !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.apiKey);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.CreateApiKeyResponseSuccess
 */
export const CreateApiKeyResponseSuccess = new CreateApiKeyResponseSuccess$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateApiKeyResponseError$Type extends MessageType<CreateApiKeyResponseError> {
    constructor() {
        super("tusk.drift.backend.v1.CreateApiKeyResponseError", [
            { no: 1, name: "code", kind: "enum", T: () => ["tusk.drift.backend.v1.CreateApiKeyResponseErrorCode", CreateApiKeyResponseErrorCode, "CREATE_API_KEY_RESPONSE_ERROR_CODE_"] },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateApiKeyResponseError>): CreateApiKeyResponseError {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.code = 0;
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<CreateApiKeyResponseError>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateApiKeyResponseError): CreateApiKeyResponseError {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* tusk.drift.backend.v1.CreateApiKeyResponseErrorCode code */ 1:
                    message.code = reader.int32();
                    break;
                case /* string message */ 2:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateApiKeyResponseError, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* tusk.drift.backend.v1.CreateApiKeyResponseErrorCode code = 1; */
        if (message.code !== 0)
            writer.tag(1, WireType.Varint).int32(message.code);
        /* string message = 2; */
        if (message.message !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message tusk.drift.backend.v1.CreateApiKeyResponseError
 */
export const CreateApiKeyResponseError = new CreateApiKeyResponseError$Type();
/**
 * @generated ServiceType for protobuf service tusk.drift.backend.v1.ClientService
 */
export const ClientService = new ServiceType$("tusk.drift.backend.v1.ClientService", [
    { name: "GetAuthInfo", options: {}, I: GetAuthInfoRequest, O: GetAuthInfoResponse },
    { name: "CreateObservableService", options: {}, I: CreateObservableServiceRequest, O: CreateObservableServiceResponse },
    { name: "VerifyRepoAccess", options: {}, I: VerifyRepoAccessRequest, O: VerifyRepoAccessResponse },
    { name: "CreateApiKey", options: {}, I: CreateApiKeyRequest, O: CreateApiKeyResponse }
]);
